var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseExtractedDetails',{attrs:{"sections":_vm.sections,"has-data":_vm.hasData,"data":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }